import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

function NotFound() {
  return (
    <section className="min-h-[60vh] bg-slate-50 flex items-center py-16 sm:py-24">
      <SEO
        title="Page Not Found"
        description="The page you requested could not be found. Return to BPA Solutions to explore our business automation, website, and workflow services."
      />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-sm font-bold uppercase tracking-[0.2em] text-blue-600 mb-4">404</p>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
          We couldn't find that page
        </h1>
        <p className="text-base sm:text-lg text-slate-600 leading-relaxed mb-8 max-w-2xl mx-auto">
          The address may have changed or been entered incorrectly. You can return home or browse our automation services.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center justify-center w-full sm:w-auto px-6 py-3 rounded-xl bg-blue-600 text-white font-bold hover:bg-blue-700 transition-colors"
          >
            Back to Home
          </Link>
          <Link
            to="/services"
            className="inline-flex items-center justify-center w-full sm:w-auto px-6 py-3 rounded-xl border border-slate-300 bg-white text-slate-800 font-bold hover:border-blue-300 hover:text-blue-700 transition-colors"
          >
            View Services
          </Link>
        </div>
      </div>
    </section>
  );
}

export default NotFound;